/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './disableAccountInvites.defs.js'
export * as $defs from './disableAccountInvites.defs.js'
